export default __webpack_public_path__ + "assets/pdf/RakocziSzovetseg_AdatkezelesiTajekoztato.pdf";